@for (item of values | keyvalue: asIsOrder; track item) {
	<input type="radio" [attr.name]="name" [id]="item.key" [value]="item.key" [formControl]="form" />
	<label tabindex="0" [attr.for]="item.key" [class.full-width]="fullWidth">
		{{ item.value }}
	</label>
}
